export default __webpack_public_path__ + "static/media/vp_search.e0072f95.png";